// Copyright (c) 2016 Deere & Company

import RgaDealerDetails, {getDefaultState as getRgaDealerDetails} from '../state/rga-dealer-details';
import actions from '../../actions-list';

const setRgaDealerDetails = (state, action) =>
    RgaDealerDetails.update(state, {
        $set: action.rgaDealerDetails
    });

const updateRgaDealerInfoValues = (state, action) => RgaDealerDetails.update(state, {
    [action.property]: {
        $set: action.value
    }
});

export default (state = getRgaDealerDetails(), action) => {

    const actionTypes = {
        [actions.UPDATE_RGA_DEALER_DETAILS]: setRgaDealerDetails,
        [actions.UPDATE_RGA_RETURNED_DEALER_INFO_VALUES]: updateRgaDealerInfoValues
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/reducers/rga-dealer-details.js